import AppError from '../../errors/AppError';
import { IPaginationReturn } from '../../interfaces/IPaginationReturn';
import IPointSituation from '../../interfaces/IPointSituation';
import { useRequest } from '../providers/useRequest';

const usePointSituation = () => {
  const situationRequest = useRequest<IPointSituation>();
  const path = 'point-control/api/situation';
  const list = async (
    perPage: number,
    currentPage: number,
    orderField: string,
    direction: 'asc' | 'desc',
  ): Promise<IPaginationReturn<IPointSituation[]>> => {
    return await situationRequest
      .getManyPaginated({
        path: `${path}?perPage=${perPage}&currentPage=${currentPage}&orderBy=${orderField}&orderDirection=${direction}`,
        sendAuthorization: true,
      })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const listById = async (id: string): Promise<IPointSituation> => {
    return await situationRequest
      .getOne({
        path: `${path}/${id}`,
        sendAuthorization: true,
      })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const create = async (resource: IPointSituation): Promise<IPointSituation> => {
    return await situationRequest
      .post({
        path: `${path}`,
        sendAuthorization: true,
        body: resource,
      })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const update = async (id: string, resource: IPointSituation): Promise<IPointSituation> => {
    return await situationRequest
      .put({
        path: `${path}/${id}`,
        sendAuthorization: true,
        body: resource,
      })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const remove = async (id: number): Promise<void> => {
    return await situationRequest
      .remove({
        path: `${path}/${id}`,
        sendAuthorization: true,
      })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  return { list, update, listById, create, remove };
};

export { usePointSituation };
